<template>
	<div class="skinPackage">
		<div id="__clroot">
			<div class="app_app__3mk8F" style="padding-bottom: 0px">
				<img :src="picUrl+'zq_pro/dzk_skinPackageThree/bg.png'" alt="" />
			</div>
			<div class="app_jumpBtn__1T7os" style="bottom: 25px;" @click="payGoClick">
				<div>
					<img alt="" :src="picUrl+'zq_pro/cyk_skinPackageThree/button.png'" />
					<div>超低购买价{{ price }}元</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'skinPackageThree',
		data() {
			return {}
		},
		props: {
			picUrl: String,
      price: [String, Number],
		},
		methods: {
			payGoClick() {
				this.$emit('paylistener')
			}
		}
	}
</script>

<style scoped>
	@-webkit-keyframes app_heartBeat___nvDd {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1);
		}

		14% {
			-webkit-transform: scale(1.05);
			transform: scale(1.05);
		}

		28% {
			-webkit-transform: scale(1);
			transform: scale(1);
		}

		42% {
			-webkit-transform: scale(1.05);
			transform: scale(1.05);
		}

		70% {
			-webkit-transform: scale(1);
			transform: scale(1);
		}
	}

	@keyframes app_heartBeat___nvDd {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1);
		}

		14% {
			-webkit-transform: scale(1.05);
			transform: scale(1.05);
		}

		28% {
			-webkit-transform: scale(1);
			transform: scale(1);
		}

		42% {
			-webkit-transform: scale(1.05);
			transform: scale(1.05);
		}

		70% {
			-webkit-transform: scale(1);
			transform: scale(1);
		}
	}

	@-webkit-keyframes app_flow__1HoT1 {
		0% {
			-webkit-transform: translateY(-0.2rem);
			transform: translateY(-0.2rem);
		}

		to {
			-webkit-transform: translateY(0.1);
			transform: translateY(0.1);
		}
	}

	@keyframes app_flow__1HoT1 {
		0% {
			-webkit-transform: translateY(-0.2rem);
			transform: translateY(-0.2rem);
		}

		to {
			-webkit-transform: translateY(0.1);
			transform: translateY(0.1);
		}
	}

	/* html {
  font-size: calc(100vw * 100 / 750);
} */

	body {
		width: 100%;
		max-width: 576px;
		margin: 0 auto;
		font-size: initial;
	}

	.app_app__3mk8F {
		min-height: 100vh;
		font-size: 0;
		position: relative;
		background-color: #126D57;
		overflow: hidden;
	}

	.app_app__3mk8F img {
		width: 100%;
	}

	.app_cardbox__2Q4GU {
		position: absolute;
		top: 10.98rem;
	}

	.app_cardbox__2Q4GU>div {
		position: absolute;
	}

	.app_cardImage__1mNzp {
		width: 20rem;
		height: 9rem;
		top: -0.53rem;
		left: -0.13rem;
		animation: app_flow__1HoT1 1s linear infinite alternate-reverse;
	}

	.app_boxImage__3ok-k,
	.app_cardImage__1mNzp {
		-webkit-background-size: cover;
		-moz-background-size: cover;
		background-size: cover;
	}

	.app_boxImage__3ok-k {
		width: 15.8rem;
		height: 11.3rem;
		left: 1.6rem;
	}

	.app_jumpBtn__1T7os {
		position: fixed;
		display: -webkit-flex;
		display: flex;
		max-width: 750px;
		width: 100%;
		margin: 0 auto;
		-webkit-justify-content: center;
		justify-content: center;
	}

	.app_jumpBtn__1T7os>div {
		width: 17.02rem;
		height: 3.19rem;
		-webkit-animation: app_heartBeat___nvDd 2s infinite;
		animation: app_heartBeat___nvDd 2s infinite;
		position: relative;
	}

	.app_jumpBtn__1T7os>div:active {
		opacity: 0.8;
	}

	.app_jumpBtn__1T7os>div img {
		width: 100%;
		height: 100%;
	}

	.app_jumpBtn__1T7os>div>div {
		font-size: 0.53rem;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0.40rem;
		text-align: center;
		color: #d81e00;
	}

	.app_jumpBtn__1T7os>div>div span {
		font-weight: bold;
		text-decoration: line-through;
	}

	.app_more__1IUPN {
		color: #d42306;
		border: 1px solid #d42306;
		font-size: 0.74rem;
		box-sizing: border-box;
		line-height: 1.43rem;
		border-radius: 0.74rem;
		left: 50%;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		text-align: center;
		top: 90.17rem;
		position: absolute;
		padding: 0 1.06rem;
		white-space: nowrap;
	}

	.app_disableMore__2awnE {
		border: none;
		color: grey;
	}
</style>
